import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { JobEntity } from './job.entity';
import { UserEntity } from './user.entity';

/** PD-17797 — a user watching a job, told of its changes in a batched alert. */
@Index('job_user__fk_user__id', ['fkUserId'], {})
@Index('job_user_pk', ['fkJobId', 'fkUserId'], { unique: true })
@Entity('job_user')
export class JobUserEntity extends BaseEntity implements EntityWatcherModel {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;
}
